module.exports = __webpack_public_path__ + "static/media/add-equipment.ee170008.svg";